import { createContext } from "react"; 

export const OTAContext = createContext(null);